import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import $ from 'jquery'
import MainLogo from '../mainassets/mainlogo.png'
import Axios from 'axios'

export default function ForgotPassword() {
  let myStyle_otp = {
    display: 'none',
    backgroundColor: '#e1eaf0',
    width: 315,
  }
  const navigate = useNavigate()
  const [user_id, setUser_id] = useState('')
  const [contact_no, setContact_No] = useState('')
  const [otp, setOtp] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [msg, setMsg] = useState('')
  const [OTPValue, setOTPValue] = useState('')
  const [IsDisplayOTP, setIsDisplayOTP] = useState(false)
  const [OTP, setOTP] = useState(new Array(6).fill(''))
  const [isShowCurrentOTP, setIsShowCurrentOTP] = useState(false)
  const [isHideSubmitButton, setIsHideSubmitButton] = useState(false)
  const [isResetFunctionSectionOpen, setIsResetFunctionOpen] = useState(false)
  const [password, setPassword] = useState('')
  const [confirm_password, setconfirm_password] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const handleChange = (element, index) => {
    const value = element.value

    if (isNaN(value)) return false

    // Update OTP array
    const newOTP = [...OTP.map((d, idx) => (idx === index ? value : d))]
    setOTP(newOTP)

    // Focus next input if current field is filled and not the last one
    if (value !== '' && index < 5) {
      const nextSibling = element.nextElementSibling
      if (nextSibling && nextSibling.tagName === 'INPUT') {
        nextSibling.focus()
      }
    }
  }

  const handleKeyDown = (e, index) => {
    // Handle backspace key
    if (e.key === 'Backspace') {
      if (OTP[index] === '' && index > 0) {
        // If current field is empty, focus previous field
        const prevSibling = e.target.previousElementSibling
        if (prevSibling && prevSibling.tagName === 'INPUT') {
          prevSibling.focus()
        }
      } else if (OTP[index] !== '') {
        // Clear current field if it has value
        const newOTP = [...OTP]
        newOTP[index] = ''
        setOTP(newOTP)
      }
    }

    // Handle left arrow key
    if (e.key === 'ArrowLeft' && index > 0) {
      const prevSibling = e.target.previousElementSibling
      if (prevSibling && prevSibling.tagName === 'INPUT') {
        prevSibling.focus()
      }
    }

    // Handle right arrow key
    if (e.key === 'ArrowRight' && index < 5) {
      const nextSibling = e.target.nextElementSibling
      if (nextSibling && nextSibling.tagName === 'INPUT') {
        nextSibling.focus()
      }
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text')
    const pastedNumbers = pastedData.replace(/[^0-9]/g, '').slice(0, 6)

    if (pastedNumbers) {
      const newOTP = [...OTP]
      for (let i = 0; i < pastedNumbers.length && i < 6; i++) {
        newOTP[i] = pastedNumbers[i]
      }
      setOTP(newOTP)

      // Focus the next empty field or the last field
      const nextEmptyIndex = newOTP.findIndex(val => val === '')
      if (nextEmptyIndex !== -1) {
        const inputs = document.querySelectorAll('.otp-field')
        if (inputs[nextEmptyIndex]) {
          inputs[nextEmptyIndex].focus()
        }
      } else if (newOTP.every(val => val !== '')) {
        const inputs = document.querySelectorAll('.otp-field')
        if (inputs[5]) {
          inputs[5].focus()
        }
      }
    }
  }

  const onuser_idChange = (e) => {
    setUser_id(e.target.value)
  }

  const onContactChange = (e) => {
    // Allow only digits (0-9) and limit to 10 characters
    const value = e.target.value.replace(/[^0-9]/g, '')
    if (value.length <= 10) {
      setContact_No(value)
    }
  }

  const onpasswordChange = (e) => {
    setPassword(e.target.value)
  }
  const onconfirm_passwordChange = (e) => {
    setconfirm_password(e.target.value)
  }

  const onsubmitform_otp = (e) => {
    e.preventDefault()
    setErrorMessage('')
    const enteredOTP = OTP.join('')
    if (enteredOTP != '') {
      if (enteredOTP === OTPValue) {
        setIsResetFunctionOpen(true)
      } else {
        setErrorMessage('Invalid OTP!')
        setIsResetFunctionOpen(false)
      }
    } else {
      setErrorMessage('Please give OTP')
    }
  }
  const location = useLocation()
  console.log(location.state)

  const onsubmitresend_otp = (e) => {
    Axios.get(`${global.baseUrl}/api/common/Misc/sendotp?phone=${contact_no}&MDT=CM`)
      .then((OTPresponse) => {
        console.log('sendOTPHandler:otp response \n', OTPresponse.data)
        if (OTPresponse.data) {
          if (OTPresponse.data.OTP_SMS_RESPONSE == 'No') {
            setIsDisplayOTP(true)
            setIsShowCurrentOTP(true)
            document.getElementById('forgot_password_div').style.display = 'none'
            document.getElementById('otp').style.display = 'block'
            navigate('/ForgotPassword')
            setOTPValue(OTPresponse.data.OTP)
            localStorage.setItem('temp_user_id', user_id)
          } else {
            setIsShowCurrentOTP(false)
            setIsDisplayOTP(false)
            setOTPValue(OTPresponse.data.OTP)
            localStorage.setItem('temp_user_id', user_id)
          }
        }
      })
      .catch((err) => {
        console.log(' otp send failed', err)
      })
  }

  const onsubmitform = (e) => {
    // Validate contact number length
    if (contact_no.length !== 10) {
      setMsg('Contact number must be exactly 10 digits')
      return
    }

    setIsHideSubmitButton(true)
    setMsg('')
    e.preventDefault()
    let formdata = $(e.target)
    formdata = new FormData()
    formdata.append('user_id', user_id)
    formdata.append('contact_no', contact_no)
    formdata.append('MDT', 'CM');
    $.ajax({
      type: 'POST',
      url: `${global.baseUrl}/api/common/Login/forgot_password`,
      data: formdata,
      processData: false,
      contentType: false,
      success(data) {
        console.log(data)
        if (data === 'success') {
          setIsHideSubmitButton(false)

          Axios.get(`${global.baseUrl}/api/common/Misc/sendotp?phone=${contact_no}&MDT=CM`)
            .then((OTPresponse) => {
              console.log('sendOTPHandler:otp response \n', OTPresponse.data)
              if (OTPresponse.data) {
                if (OTPresponse.data.OTP_SMS_RESPONSE == 'No') {
                  setIsDisplayOTP(true)

                  document.getElementById('forgot_password_div').style.display = 'none'
                  document.getElementById('otp').style.display = 'block'
                  navigate('/ForgotPassword')
                  setIsShowCurrentOTP(true)

                  setOTPValue(OTPresponse.data.OTP)
                  localStorage.setItem('temp_user_id', user_id)
                } else {
                  document.getElementById('forgot_password_div').style.display = 'none'
                  document.getElementById('otp').style.display = 'block'
                  navigate('/ForgotPassword')
                  setIsShowCurrentOTP(false)
                  localStorage.setItem('temp_user_id', user_id)
                  setOTPValue(OTPresponse.data.OTP)

                  setIsDisplayOTP(true)
                }
              }
            })
            .catch((err) => {
              console.log(' otp send failed', err)
              setIsHideSubmitButton(false)
            })
        } else {
          setMsg('User id or contact no does not match.')
          setIsHideSubmitButton(false)
        }
      },
      error: function (err) {
        console.log(err)
      },
    })
  }

  const onSubmitResetForm = (e) => {
    $('button#submitbutton').css('display', 'none')
    setErrorMessage('')
    e.preventDefault()
    if (password === confirm_password) {
      let formdata = $(e.target)
      formdata = new FormData()
      formdata.append('password', password)
      formdata.append('confirm_password', confirm_password)
      formdata.append('user_id', localStorage.getItem('temp_user_id'))
      formdata.append('loggedin_user_id', localStorage.getItem('temp_user_id'))
      formdata.append('MDT', 'CM');
      $.ajax({
        type: 'POST',
        url: `${global.baseUrl}/api/common/Login/reset_password_clinic`,
        data: formdata,
        processData: false,
        contentType: false,
        success(data) {
          console.log(data)
          if (data == 'success') {
            setSuccessMessage('Updated Successfully redirecting to Login page')
            setTimeout(() => {
              navigate('/')
            }, 3000)
          }
        },
        error: function (err) {
          console.log(err)
          $('button#submitbutton').css('display', 'block')
        },
      })
    } else {
      $('button#submitbutton').css('display', 'block')
      setErrorMessage('Password and Confirm Password must be same')
    }
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }}>
        <div className="col-lg-4">
          <div className="content-area-card">
            <div
              className="card-innr card-innr-fix"
              id="forgot_password_div"
              style={{ backgroundColor: '#e1eaf0', width: '100%' }}
            >
              <div className="card-head" style={{ textAlign: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <img
                    className="image"
                    src={MainLogo}
                    style={{ height: 100, width: 100, paddingTop: 10 }}
                  />
                </div>

                <h6
                  className="card-title"
                  style={{ marginTop: 15, fontWeight: 'bold', fontSize: 18 }}
                >
                  Forgot Password
                </h6>
                <p className="card-title" style={{ marginTop: 1, color: 'black', fontWeight: 400 }}>
                  {location.state == 'clinic' ? 'Clinic' : 'Doctor'}@ HealthConnect Pro
                </p>
              </div>

              <div style={{ textAlign: 'left' }} className="input-item input-with-label">
                <label
                  htmlFor="user_id"
                  className="col-form-label"
                  style={{
                    fontSize: 15,
                    color: '#7781A9',
                    textAlign: 'left',
                    marginLeft: 25,
                    marginBottom: 0,
                  }}
                >
                  {' '}
                  User Id *
                </label>

                <br />
                <input
                  style={{
                    border: '1px solid gray',
                    height: 40,
                    paddingLeft: 8,
                    marginLeft: 25,
                    fontSize: 9,
                    borderRadius: 4,
                    fontSize: 'small',
                    width: '90%',
                  }}
                  type="text"
                  name="user_id"
                  required
                  placeholder="User ID"
                  className="input-bordered"
                  value={user_id}
                  onChange={onuser_idChange}
                  maxLength={10}
                  autoComplete="off"
                />
              </div>
              <div style={{ textAlign: 'left' }} className="input-item input-with-label">
                <label
                  htmlFor="password"
                  className="col-form-label"
                  style={{
                    fontSize: 15,
                    color: '#7781A9',
                    textAlign: 'left',
                    marginLeft: 25,
                    marginBottom: 0,
                  }}
                >
                  Contact No *
                </label>

                <input
                  style={{
                    border: '1px solid gray',
                    height: 40,
                    paddingLeft: 8,
                    marginLeft: 25,
                    fontSize: 9,
                    borderRadius: 4,
                    fontSize: 'small',
                    width: '90%',
                  }}
                  type="tel"
                  name="contact_no"
                  autoComplete="off"
                  required
                  placeholder="Contact No. (10 digits)"
                  className="input-bordered"
                  value={contact_no}
                  onChange={onContactChange}
                  maxLength={10}
                  pattern="[0-9]{10}"
                  title="Please enter exactly 10 digits"
                />
                {contact_no.length > 0 && contact_no.length !== 10 && (
                  <p style={{ fontSize: 12, color: 'red', marginLeft: 25, marginTop: 5 }}>
                    Contact number must be exactly 10 digits
                  </p>
                )}
              </div>

              <br />
              {msg ? (
                <p style={{ fontSize: 14, fontWeight: 'bold', color: 'red', marginLeft: 5 }}>
                  {msg}
                </p>
              ) : null}
              <div style={{ textAlign: 'center' }}>
                {isHideSubmitButton == false ? (
                  <button
                    style={{ width: '40%', marginTop: 5, backgroundColor: '#1c65c9' }}
                    type="submit"
                    onClick={onsubmitform}
                    className="btn btn-primary "
                    disabled={contact_no.length !== 10}
                  >
                    Submit
                  </button>
                ) : (
                  <p style={{ fontSize: 14, fontWeight: 'bold', color: 'green' }}>Please wait...</p>
                )}
                <div style={{ marginTop: 10 }}>
                  <a
                    style={{
                      fontSize: 18,
                      color: '#1c65c9',
                      paddingBottom: 10,
                      textDecoration: 'none',
                    }}
                    href="/"
                  >
                    Go to Login{' '}
                  </a>
                </div>
              </div>
            </div>

            {isResetFunctionSectionOpen == false ? (
              <div className="page-ath-form" id="otp" style={myStyle_otp}>
                <div className="card-head">
                  <h6
                    className="card-title"
                    style={{
                      marginTop: 15,
                      marginLeft: 10,
                      fontWeight: 'bold',
                      textAlign: 'center',
                      paddingTop: 10,
                    }}
                  >
                    OTP
                  </h6>
                </div>
                <div style={{ textAlign: 'center' }} className="input-item input-with-label">
                  {isShowCurrentOTP == true ? (
                    <p style={{ marginTop: 15, marginLeft: 8, textAlign: 'center' }}>
                      Your current OTP is : {OTPValue}
                    </p>
                  ) : (
                    <p style={{ textAlign: 'center' }}>
                      Enter OTP sent to your mobile XXXXXXX{contact_no.substr(-3)}{' '}
                    </p>
                  )}

                  <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '15px' }}>
                    {OTP.map((data, index) => {
                      return (
                        <input
                          className="otp-field"
                          type="tel"
                          name="otp"
                          maxLength="1"
                          key={index}
                          value={data}
                          style={{
                            height: 35,
                            width: 35,
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontSize: 18,
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            outline: 'none',
                            transition: 'all 0.2s ease',
                          }}
                          onChange={(event) => handleChange(event.target, index)}
                          onKeyDown={(event) => handleKeyDown(event, index)}
                          onFocus={(e) => e.target.select()}
                          onPaste={handlePaste}
                        />
                      )
                    })}
                  </div>
                </div>
                {errorMessage && (
                  <div className="error" style={{ textAlign: 'center' }}>
                    {' '}
                    <p style={{ color: 'red', fontSize: 14, fontWeight: 'bold' }}>
                      {errorMessage}
                    </p>{' '}
                  </div>
                )}

                <br />
                <div style={{ textAlign: 'center' }} className="input-item input-with-label">
                  <a
                    type="submit"
                    onClick={onsubmitresend_otp}
                    className="resend"
                    style={{
                      fontSize: 15,
                      fontWeight: 'bold',
                      color: 'clue',
                      color: '#2c80ff',
                      textDecoration: 'none',
                    }}
                  >
                    RESEND OTP?
                  </a>
                </div>
                <div style={{ marginTop: 15, marginBottom: 10, textAlign: 'center' }}>
                  <button
                    style={{ backgroundColor: '#2c80ff', marginBottom: 20 }}
                    type="submit"
                    onClick={onsubmitform_otp}
                    className="btn btn-primary"
                  >
                    Submit
                  </button>
                </div>
              </div>
            ) : (
              <div className="page-ath-form" id="otp" style={myStyle_otp}>
                <div className="card-head">
                  <h6
                    className="card-title"
                    style={{
                      marginTop: 40,
                      textAlign: 'center',
                      fontSize: 20,
                      color: '#04066b',
                      paddingTop: 20,
                    }}
                  >
                    RESET PASSWORD
                  </h6>
                  <p style={{ textAlign: 'center', fontSize: 16 }}>
                    {localStorage.getItem('temp_user_id')}
                  </p>
                </div>
                <div style={{ textAlign: 'left' }} className="input-item input-with-label">
                  <label
                    htmlFor="user_id"
                    className="col-form-label"
                    style={{ textAlign: 'left', marginLeft: 30, fontSize: 15, color: '#7781A9' }}
                  >
                    Password
                  </label>
                  <br />
                  <input
                    style={{
                      border: '1px solid gray',
                      height: 40,
                      paddingLeft: 8,
                      fontSize: 12,
                      borderRadius: 4,
                      fontSize: 'small',
                      width: '90%',
                      marginLeft: 30,
                    }}
                    type="password"
                    name="user_id"
                    required
                    placeholder="Password"
                    className="input-bordered"
                    value={password}
                    onChange={onpasswordChange}
                    maxLength={10}
                  />
                </div>

                <div style={{ textAlign: 'left' }} className="input-item input-with-label">
                  <label
                    htmlFor="password"
                    className="col-form-label"
                    style={{ textAlign: 'left', marginLeft: 30, fontSize: 15, color: '#7781A9' }}
                  >
                    Confirm Password
                  </label>
                  <br />
                  <input
                    style={{
                      border: '1px solid gray',
                      height: 40,
                      paddingLeft: 8,
                      fontSize: 9,
                      borderRadius: 4,
                      fontSize: 'small',
                      width: '90%',
                      marginLeft: 30,
                    }}
                    type="password"
                    name="password"
                    autoComplete="off"
                    required
                    placeholder="Confirm Password"
                    className="input-bordered"
                    value={confirm_password}
                    onChange={onconfirm_passwordChange}
                    maxLength={10}
                  />
                </div>

                {errorMessage && (
                  <div className="error" style={{ textAlign: 'center' }}>
                    {' '}
                    <p style={{ color: 'red', fontSize: 14, fontWeight: 'bold' }}>
                      {errorMessage}
                    </p>{' '}
                  </div>
                )}
                {successMessage && (
                  <div style={{ textAlign: 'center' }}>
                    {' '}
                    <p style={{ color: 'green', fontSize: 14, fontWeight: 'bold', marginTop: 15 }}>
                      {successMessage}
                    </p>{' '}
                  </div>
                )}

                <br />
                <div style={{ textAlign: 'center' }}>
                  <button
                    style={{
                      marginBottom: 30,
                      backgroundColor: '#0f809a',
                      textColor: 'white',
                      paddingLeft: 60,
                      paddingRight: 60,
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}
                    id="submitbutton"
                    type="submit"
                    onClick={onSubmitResetForm}
                    className="btn btn-primary "
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}